/** Meta description for /book, /changes, and /cancellation airline pages. */
export function getAirlineMetaDescription(airlineName) {
  return `Looking to book or change your ${airlineName} flight? The Final Seat LLC provides immediate live concierge booking, routing assistance, and urgent itinerary support.`;
}
